var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.DataTypeShape = {
    is_gridded: function () {
        return false;
    },
    get_data_variable: function (data_var) {
        if (OCS.Utilities.is_string(data_var)) {
            data_var = {'parm': data_var};
        }
        var data = this.data();
        var vars = this.get_variables();
        if (vars.contains(data_var.parm)) {
            return OCS.Utilities.array_has_object_with_prop(data.features, {id: data_var.parm});
        }
        return false;
    },
    get_variables: function () {
        var data = this.data();
        var vars = [];
        if (data.features && data.features.length) {
            var features = data.features;
            var i = 0;
            for (i; i < features.length; i++) {
                vars.push(features[i].id);
            }
        }

        return vars;
    },
    get_variable_units: function () {

    },
    add_data_variable: function (data_in, variable) {
        var existing_data = this.data().features;
        if (data_in && data_in.type === "Feature") {
            existing_data.combine([data_in]);
        }
        if (data_in && data_in.type === "FeatureCollection" && data_in.features && data_in.features.length) {
            data_in.features.each(function (feature) {
                existing_data.combine([feature]);
            });
        }
    }
};